<template>
  <div class="h-full bg-gray-50 flex flex-col">
    <!-- Header -->
    <div class="bg-white border-b border-gray-200 px-4 py-3 flex items-center gap-3 shrink-0">
      <button @click="$emit('back')" class="text-gray-400 hover:text-gray-600">
        <FontAwesomeIcon :icon="['fas', 'arrow-left']" />
      </button>
      <div class="flex-1 min-w-0">
        <div class="flex items-center gap-2">
          <span :class="typeBadgeClass">{{ opportunitySummary?.type || 'Task' }}</span>
          <span class="text-xs font-medium text-gray-900">{{ opportunitySummary?.hcc_code || '' }}</span>
          <span class="text-[10px] px-1.5 py-0.5 rounded bg-gray-100 text-gray-600 font-medium">{{ tierLabel }}</span>
        </div>
        <div class="text-[10px] text-gray-500 truncate mt-0.5">
          {{ opportunitySummary?.description || taskTypeDescription }}
        </div>
      </div>
    </div>

    <!-- Workspace -->
    <Coding_Task_Workspace
      :task-id="taskId"
      @task-completed="handleTaskCompleted"
      @task-loaded="onTaskLoaded"
      class="flex-1 min-h-0"
    />
  </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import Coding_Task_Workspace from './Coding_Task_Workspace.vue';

const TIER_LABELS = {
  1: '1LR', 2: '2LR', 3: '3LR', 4: 'Confirm',
  6: '1LR', 7: '2LR', 9: '3LR', 8: 'Confirm',
  10: '1LR', 11: '2LR', 12: '3LR', 13: 'Confirm',
};

export default {
  name: 'Coding_Opportunity_Drawer',
  components: {
    FontAwesomeIcon,
    Coding_Task_Workspace,
  },
  props: {
    taskId: { type: Number, required: true },
    patientName: { type: String, default: '' },
    opportunitySummary: { type: Object, default: null },
  },
  emits: ['back', 'task-completed'],
  data() {
    return {
      taskTypeId: null,
      taskTypeName: '',
      taskTypeDescription: '',
    };
  },
  computed: {
    tierLabel() {
      // Fall back to the task type's display name when the id is outside
      // the canonical 1LR/2LR/3LR/Confirm map (e.g., a future task type).
      return TIER_LABELS[this.taskTypeId] || this.taskTypeName || '';
    },
    typeBadgeClass() {
      const base = 'inline-flex px-2 py-0.5 text-[10px] font-medium rounded';
      switch (this.opportunitySummary?.type) {
        case 'Suspect': return `${base} bg-[#EBF4FF] text-[#4C6E97]`;
        case 'Recapture': return `${base} bg-[#F1F9F0] text-[#88A484]`;
        case 'Resubmissions': return `${base} bg-[#FFF7F4] text-[#9F4D30]`;
        default: return `${base} bg-gray-100 text-gray-700`;
      }
    },
  },
  methods: {
    onTaskLoaded(task) {
      this.taskTypeId = task?.task_type;
      this.taskTypeName = task?.task_type_name || '';
      this.taskTypeDescription = task?.task_type_description || '';
    },
    handleTaskCompleted(payload) {
      this.$emit('task-completed', payload?.taskId);
    },
  },
};
</script>
